import React from 'react';
import PropTypes from 'prop-types';
import Title from '../base/Title/Title';
import ChooseCompany from './ChooseCompany';
import FillCompany from './FillCompany';
import CheckBox from '../base/Checkbox/Checkbox';
import textTranslates from './translate.json';
import './Customer.scss';

function onTitleClick() {
    $('#company-props').collapse();
}

const CustomerCompany = ({customerType, companyName, newCustomer, onCompanyNameChanged, onCompanyTaxChanged, onEditCompanyButtonClick, onNewCustomerChange, companyTax,isMyCompanyNotFoundCheckBoxVisible}) => {
    if (customerType != "" && (customerType === "CorporateEntity")) {
        return(
            <div 
                id="customer-company"
                className="col-xs-12 customer-company">
                <Title
                    id="companyTitle"
                    title={textTranslates.companyTitle}
                    onClick={onTitleClick}
                    data-toggle="collapse" data-parent="#accordion" href="#company-props" aria-expanded="true" aria-controls="company-props"/>
                {!newCustomer &&
                <ChooseCompany
                    companyName={companyName}
                    companyTax={companyTax}
                    onEditCompanyButtonClick={onEditCompanyButtonClick}/> }
                {newCustomer &&
                    <FillCompany
                        companyName={companyName}
                        companyTax={companyTax}
                        onCompanyNameChanged={onCompanyNameChanged}
                        onCompanyTaxChanged={onCompanyTaxChanged}/> }
                {isMyCompanyNotFoundCheckBoxVisible &&
                    <div className="col-xs-12 col-sm-12">
                        <CheckBox 
                            onChange={onNewCustomerChange}
                            value={newCustomer} >
                            Nie znaleziono mojej firmy
                        </CheckBox>
                    </div>
                }
            </div>
        );
    }
    return null;
};

CustomerCompany.propTypes = {
    customerType: PropTypes.string,
    companyName: PropTypes.string,
    companyTax: PropTypes.string,
    newCustomer: PropTypes.bool,
    onCompanyNameChanged: PropTypes.func,
    onCompanyTaxChanged: PropTypes.func,
    onEditCompanyButtonClick: PropTypes.func,
    onNewCustomerChange: PropTypes.func,
    showComponent: PropTypes.bool,
};

export default CustomerCompany;


// WEBPACK FOOTER //
// ./src/components/Customer/CustomerCompany.js